export default {
  BASE_URL: 'https://api.v2.affixe-logiciel.fr/api/',
  AUTHORITY_URL: 'https://id.v2.affixe-logiciel.fr/',
};



// WEBPACK FOOTER //
// ./src/api/config/config.prod.js